module.exports = __webpack_public_path__ + "img/logo.76d7d6ac.png";